export default function () {
  return [
    {
      path: '/articles',
      name: 'Articles',
      component: () => import(/* webpackChunkName: "communityManagement" */ '@views/communityManagement/articles'),
      meta: {
        title: 'articles',
        needLogin: true
      }
    },
    {
      path: '/community',
      name: 'Community',
      component: () => import(/* webpackChunkName: "communityManagement" */ '@views/communityManagement/community'), // 社区
      meta: {
        title: 'community',
        needLogin: false
      }
    },
    {
      path: '/community/detail',
      name: 'CommunityDetail',
      component: () => import(/* webpackChunkName: "communityManagement" */ '@views/communityManagement/detail'), // 社区
      meta: {
        title: 'CommunityDetail',
        needLogin: false
      }
    }
  ];
};
